import AdminLayout from './AdminLayout';
import PropTypes from 'prop-types';

/**
 * Layout base unificado para todas las secciones CRUD del panel de administración
 * Proporciona una estructura consistente y responsiva para todas las secciones
 */
const AdminCRUDLayout = ({
  title,
  subtitle,
  children,
  headerActions,
  loading = false,
  error = null,
  onErrorDismiss,
  className = ''
}) => {
  return (
    <AdminLayout title={title} subtitle={subtitle}>
      <div className={`admin-crud-layout ${className}`}>
        {/* Header con acciones */}
        {headerActions && (
          <div className="admin-content-header">
            <div className="header-actions">
              {headerActions}
            </div>
          </div>
        )}

        {/* Mensaje de error global */}
        {error && (
          <div className="admin-error-banner">
            <div className="error-content">
              <span className="material-icons">error</span>
              <span className="error-message">{error}</span>
              {onErrorDismiss && (
                <button
                  className="error-dismiss"
                  onClick={onErrorDismiss}
                  aria-label="Cerrar error"
                >
                  <span className="material-icons">close</span>
                </button>
              )}
            </div>
          </div>
        )}

        {/* Estado de carga global */}
        {loading ? (
          <div className="admin-loading-state">
            <div className="loading-spinner">
              <div className="spinner"></div>
              <span>Cargando...</span>
            </div>
          </div>
        ) : (
          /* Contenido principal */
          <div className="admin-crud-content">
            {children}
          </div>
        )}
      </div>
    </AdminLayout>
  );
};

AdminCRUDLayout.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  children: PropTypes.node.isRequired,
  headerActions: PropTypes.node,
  loading: PropTypes.bool,
  error: PropTypes.string,
  onErrorDismiss: PropTypes.func,
  className: PropTypes.string
};

export default AdminCRUDLayout;
